import { Option } from 'types'

export const SERVICE_REQUEST_STATUS_OPTIONS: Option[] = [
  {
    label: 'Pendente',
    value: 'PENDING',
  },
  {
    label: 'Em atendimento',
    value: 'INVESTIGATING',
  },
  {
    label: 'Aprovado',
    value: 'ACCEPTED',
  },
  {
    label: 'Rejeitado',
    value: 'REJECTED',
  },
]
